import { createAsyncThunk } from "@reduxjs/toolkit";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";

const DEV_BASE_URL = process.env.REACT_APP_BASE_URL_OTHER_SERVICES;

export const getCancellationGridReport = createAsyncThunk(
    "/summary/cancellation-grid/report",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/summary/cancellation-grid/report", data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const uploadCancellationGridReport = createAsyncThunk(
    "/summary/cancellation-grid",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/summary/cancellation-grid", data, {
                headers: {
                    "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
